module.exports = __webpack_public_path__ + "static/media/warsaw.5cffed2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/warsaw.png
// module id = 866
// module chunks = 0